import Image from "next/image";
import styled from "styled-components";
import { device } from "../../styles/device";
import UploadSVG from "/public/svg/img.svg";

const CompanyHeaderContainer = styled.div`
  position: relative;
  width: 100%;
  /*     max-width: 1600px; */
  /*     height: 130px; */
  margin: auto;
  padding: 17.5235% 0 0 0;

  /*  @media ${device.tablet} {
        height: auto;
      height: 250px; 
    }

   @media ${device.laptop} {
        height: 300px;
    } */
`;

const BannerPlaceholderContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: 0px;
  height: 100%;
  width: 100%;
  border: none;
  background-color: ${(props) => props.theme.colors.buttonSubtle};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    height: 50px;
    width: 50px;
  }
`;

export default function CompanyHeader({ title, srcURL, bucketUrl }) {
  return (
    <CompanyHeaderContainer>
      {srcURL != null && srcURL != "" ? (
        <Image
          layout="fill"
          priority
          alt={`Cover Image for ${title}`}
          src={bucketUrl + srcURL}
          objectFit="cover"
          loading="eager"
          quality={100}
        />
      ) : (
        <BannerPlaceholderContainer>
          <UploadSVG />
        </BannerPlaceholderContainer>
      )}
    </CompanyHeaderContainer>
  );
}
